<div class="cus_con_wrapper">
	<div class="page-container cus_cont product_listing_container_wrapper">
	<!-- TODO: do not remove
		<fb-image-carousel [dataImageCarousel]="tempListingFeaturedProduct"></fb-image-carousel>
	-->

		<div class="product_listing_sontainer">
			<div class="product_filter_cont">

				<div class="sidebar_sticky">
					<div class="chips_cont">
						<fb-chips-filter [productList]="this.products"></fb-chips-filter>

					</div>
					<p *ngIf="!productLength" class="showing_products_number">Fetching... Products</p>
					<p *ngIf="productLength" class="showing_products_number">Showing {{productLength}} Products</p>
					<fb-product-filter-sidebar class="" [productList]="this.products"
											   (onFilterChangeProductLength)="productLengthUpdate($event)"></fb-product-filter-sidebar>
				</div>
			</div>
			<div class="product_details">
				<fb-product-listing (productList)="listingDataPassToFilter($event)"></fb-product-listing>

			</div>
		</div>
	</div>
</div>


